import { render, staticRenderFns } from "./postList.vue?vue&type=template&id=7c56a99b"
import script from "./postList.vue?vue&type=script&lang=js"
export * from "./postList.vue?vue&type=script&lang=js"
import style0 from "./postList.vue?vue&type=style&index=0&id=7c56a99b&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c56a99b')) {
      api.createRecord('7c56a99b', component.options)
    } else {
      api.reload('7c56a99b', component.options)
    }
    module.hot.accept("./postList.vue?vue&type=template&id=7c56a99b", function () {
      api.rerender('7c56a99b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/redBook/component/postList.vue"
export default component.exports